import {Box, Button, makeStyles} from '@material-ui/core';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import lockIcon from '@material-ui/icons/Lock';
import Icon from "@material-ui/core/Icon";
import {useFeature} from "flagged";

const useStyles = makeStyles(() => ({
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    padding: '6px 27px',
    background: '#017AEF',
    margin:"10px",
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '&:disabled': {
      background: '#c0c5c8',
      color: '#474646',
    },
    textTransform: 'none'
  },
  btnCancel: {
    padding: '0 18px',
    height: 41,
    borderRadius: 6,
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#e2e2e2',
      color: '#697683',
    },
    marginRight: 12
  },
  icon: {
    width: 28,
    height: 28,
    marginLeft: 10
  },
  pressDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  press: {
    fontFamily: 'roboto-regular',
    fontSize: 10,
    color: '#212D40'
  },
  enter: {
    fontFamily: 'roboto-bold',
    fontSize: 10,
    color: '#212D40'
  },
  videoBtn: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    padding: '6px 27px',
    background: '#F0F0F0',
    color: '#697683',
    textTransform: 'none',
    boxShadow: 'unset',
    '&:hover': {
      boxShadow: 'unset',
      background: '#e2e2e2',
      color: '#697683',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
      fontSize: 11,
    },
    width: 127
  },
  videoBtnNext: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    padding: '6px 27px',
    background: '#017AEF',
    margin:"10px",
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '&:disabled': {
      background: '#c0c5c8',
      color: '#474646',
    },
    textTransform: 'none',
    width: 127
  }
}));

function CreatorBtn(props: any) {

  const classes = useStyles();
  const {
    title, type, isEnabled, isValidation, isRight, goNext, loading, style, closeCreateReel, showArrow, showVideoBtn,
    uploadVideo, enableVideoBtn
  } = props;
  const hasFeatureReels = useFeature('feature_reels');

  const onUploadVideo = () => {
    hasFeatureReels && uploadVideo();
  };

  return (
    title ? (
      isRight ? (
        (type === "reel") ? (
          <Box mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' sx={style ? {...style} : {}}>
            {showVideoBtn ? (
              <Button className={classes.videoBtn} variant="contained" size='large' onClick={onUploadVideo} disabled={!enableVideoBtn}>
                {!hasFeatureReels && (
                  <Icon component={lockIcon} color="primary"/>
                )}
                <img src={'/assets/icons/creatordashboard/project-add.svg'} alt={'img'} style={{ opacity: enableVideoBtn ? 1 : 0.4 }}/>
                Video
              </Button>
            ) : (
              <Button className={classes.btnCancel} size='large' onClick={closeCreateReel}>
                Oops, No
              </Button>
            )}
            <Button className={classes.videoBtnNext} color='primary' size='large' onClick={goNext}>
              {title}
              <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon}/>
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div className={classes.pressDiv}>
              <span className={classes.press}>press</span>&nbsp;
              <span className={classes.enter}>Enter</span>
            </div>
          </Box>
        ) : ( 
          <Box mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' sx={style ? {...style} : {}}>
            <Button className={classes.btn} color='primary' size='large' onClick={goNext}>
              {title}
              {showArrow && <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon}/>}
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div className={classes.pressDiv}>
              <span className={classes.press}>press</span>&nbsp;
              <span className={classes.enter}>Enter</span>
            </div>
          </Box> 
        )
      ) : (
        <Box mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent='center' sx={style ? {...style} : {}}>
          <Button className={classes.btn} color='primary' size='large' onClick={goNext}>
            {title}
          </Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div className={classes.pressDiv}>
            <span className={classes.press}>press</span>&nbsp;
            <span className={classes.enter}>Enter</span>
          </div>
        </Box>
      )
    ) : (
      <Box mt={4} display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' sx={style ? {...style} : {}}>
        {loading ? <CircularProgress color="inherit" size={20}/> : (
          <>
            {showVideoBtn && (
              <Button className={classes.videoBtn} variant="contained" size='large' onClick={onUploadVideo} disabled={!enableVideoBtn}>
                {!hasFeatureReels && (
                  <Icon component={lockIcon} color="primary"/>
                )}
                <img src={'/assets/icons/creatordashboard/project-add.svg'} alt={'img'} style={{ opacity: enableVideoBtn ? 1 : 0.4 }}/>
                Video
              </Button>
            )}
            <Button className={classes.videoBtnNext} color='primary' size='large' disabled={!isEnabled && isValidation} onClick={goNext}>
              Next
              <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon}/>
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div className={classes.pressDiv}>
              <span className={classes.press}>press</span>&nbsp;
              <span className={classes.enter}>Enter</span>
            </div>
          </>
        )}
      </Box>
    )
  );
}

export default CreatorBtn;
